export const actionTypes: any = {
  CHECK_DUPLICATE_CIF_START: 'CHECK_DUPLICATE_CIF_START',
  CHECK_DUPLICATE_CIF_SUCCESS: 'CHECK_DUPLICATE_CIF_SUCCESS',
  CHECK_DUPLICATE_CIF_FAILURE: 'CHECK_DUPLICATE_CIF_FAILURE',
  RESET_DUPLICATE_CIF_STATE: 'RESET_DUPLICATE_CIF_STATE',
}
